module.exports = __webpack_public_path__ + "img/logo-scan.4e84c671.svg";